"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._ResolveIpToGPS = void 0;
var ipResolver = 'https://ip-resolving-geolocation.marketing-783.workers.dev/api/location';
var cachedPosition = undefined;
var _ResolveIpToGPS = function () { return __awaiter(void 0, void 0, void 0, function () {
    var controller, timeout, response, position, _a, latitude, longitude, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (cachedPosition) {
                    return [2 /*return*/, cachedPosition];
                }
                controller = new AbortController();
                timeout = setTimeout(function () { return controller.abort(); }, 3000);
                _c.label = 1;
            case 1:
                _c.trys.push([1, 4, 5, 6]);
                return [4 /*yield*/, fetch(ipResolver, { credentials: 'omit', signal: controller.signal })];
            case 2:
                response = _c.sent();
                if (!response.ok) {
                    return [2 /*return*/, undefined];
                }
                return [4 /*yield*/, response.json()];
            case 3:
                position = _c.sent();
                if (!position || typeof position !== 'object') {
                    return [2 /*return*/, undefined];
                }
                _a = position, latitude = _a.latitude, longitude = _a.longitude;
                if (typeof latitude !== 'number' ||
                    !Number.isFinite(latitude) ||
                    latitude < -90 ||
                    latitude > 90 ||
                    typeof longitude !== 'number' ||
                    !Number.isFinite(longitude) ||
                    longitude < -180 ||
                    longitude > 180) {
                    return [2 /*return*/, undefined];
                }
                cachedPosition = { latitude: latitude, longitude: longitude };
                return [2 /*return*/, cachedPosition];
            case 4:
                _b = _c.sent();
                return [3 /*break*/, 6];
            case 5:
                clearTimeout(timeout);
                return [7 /*endfinally*/];
            case 6: return [2 /*return*/, undefined];
        }
    });
}); };
exports._ResolveIpToGPS = _ResolveIpToGPS;
